import React from "react";
import styled from "styled-components";
import BorderTop from "../../../assets/sprites/paper/paper_top.gif";
import BorderTopRight from "../../../assets/sprites/paper/paper_topright.gif";
import BorderTopLeft from "../../../assets/sprites/paper/paper_topleft.gif";
import BorderLeft from "../../../assets/sprites/paper/paper_left2.gif";
import BorderRight from "../../../assets/sprites/paper/paper_right.gif";
import BorderBotLeft from "../../../assets/sprites/paper/paper_bottomleft2.gif";
import BorderBot from "../../../assets/sprites/paper/paper_bottom.gif";
import BorderBotRight from "../../../assets/sprites/paper/paper_bottomright.gif";

const PaperContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const PaperRow = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: row;
`;
const PaperMidRow = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: row;
`;

const TopLeft = styled.div`
  background: url(${BorderTopLeft});
  width: 12px;
  height: 11px;
`;

const TopMid = styled.div`
  background: url(${BorderTop});
  background-repeat: repeat-x;
  height: 11px;
  width: calc(100% - 24px);
`;

const TopRight = styled.div`
  background: url(${BorderTopRight});
  width: 12px;
  height: 11px;
`;

const MidLeft = styled.div`
  background: url(${BorderLeft});
  width: 12px;
`;

const Mid = styled.div`
  width: calc(100% - 12px);
  max-width: calc(100% - 12px);
  background: #fbead0;
  display: flex;
  flex-direction: column;
  padding: 1.5rem 1.5rem;

  max-width: calc(100% - 12px);
`;

const MidRight = styled.div`
  background: url(${BorderRight});
  width: 12px;
`;

const BotLeft = styled.div`
  background: url(${BorderBotLeft});
  width: 12px;
  height: 16px;
`;
const BotMid = styled.div`
  background: url(${BorderBot});
  background-repeat: repeat-x;
  height: 12px;
  width: calc(100% - 24px);
`;
const BotRight = styled.div`
  width: 12px;
  height: 16px;
  background: url(${BorderBotRight});
`;

export default function Paper(props: any) {
  return (
    <>
      <PaperContainer>
        <PaperRow>
          <TopLeft></TopLeft>
          <TopMid></TopMid>
          <TopRight></TopRight>
        </PaperRow>
        <PaperMidRow>
          <MidLeft></MidLeft>
          <Mid>{props.children}</Mid>
          <MidRight></MidRight>
        </PaperMidRow>
        <PaperRow>
          <BotLeft></BotLeft>
          <BotMid></BotMid>
          <BotRight></BotRight>
        </PaperRow>
      </PaperContainer>
    </>
  );
}
